import { useState as r, useCallback as n, useEffect as x } from "react";
const v = t => {
  const [c, e] = r(!0),
    [s, u] = r(!0),
    a = n(() => {
      t && t.scrollPrev();
    }, [t]),
    i = n(() => {
      t && t.scrollNext();
    }, [t]),
    l = n(o => {
      e(!o.canScrollPrev()), u(!o.canScrollNext());
    }, []);
  return x(() => {
    t && (l(t), t.on("reInit", l), t.on("select", l));
  }, [t, l]), {
    prevBtnDisabled: c,
    nextBtnDisabled: s,
    onPrevButtonClick: a,
    onNextButtonClick: i
  };
};
export { v as useCarouselPrevNextButtons };